import { useNavigate } from "react-router-dom";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";

function Footer(){
    const navigate = useNavigate();

    return(
        <footer>
            <div>
                <ul className='footer-nav footer'>
                    <li><span>Main Menu</span></li>
                    <li onClick={() => navigate('/')}>Home</li>
                    <li onClick={() => navigate('/gallery')}>Solutions</li>
                    <li onClick={() => navigate('/about')}>About Us</li>
                    <li onClick={() => navigate('/contact')}>Contact</li>
                    <li onClick={() => navigate('/send-digital-files')}>Send a Case</li>
                </ul>
            </div>
            <div>
                <ul style={{textAlign: 'center'}} className='footer'>
                    <li className='footer-header'>Osseo Dental Prosthetics</li>
                    <li>#115, 2841 - 109 Street NW</li>
                    <li>Edmonton, AB T6J 6B7</li>
                    <li>Mon - Thur 9am - 6pm / Fri 9am - 4pm</li>
                    <li>Evening Appointments Available Upon Request</li>
                    <li><FaPhoneAlt/> 780 - 469 - 7757</li>
                </ul>
            </div>
            <div className='footer-nav'>
                <ul style={{textAlign: 'right'}} className='footer'>
                    <li><span>Contact Us</span></li>
                    <li onClick={() => navigate('/contact')}>Email Us</li>
                    <li onClick={() => navigate('/contact')}>Call Us</li>
                    <FaInstagram className='ig-icon' onClick={() => window.open('https://www.instagram.com/osseodentallab/')}/>
                </ul>
            </div>
        </footer>
    )
}
export default Footer;